











import Vue from "vue";

import IconWhiteCheck from "../../assets/icons/white/Check.svg";

interface Props {
  icon: string;
}

export default Vue.extend<Props>({
  name: "JzIconCorrect",
  functional: true,
  props: {
    icon: { type: String, default: IconWhiteCheck }
  }
});
